/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Awaiting_TitleInputs */



/**
* | output |
* | --- |
* | "These agents wait for approval before irreversible actions" |
*
* @param {Agent_Policy_Destructive_Awaiting_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_awaiting_title = /** @type {((inputs?: Agent_Policy_Destructive_Awaiting_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Awaiting_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Agenten warten vor unumkehrbaren Aktionen auf Freigabe")
	return /** @type {LocalizedString} */ ("These agents wait for approval before irreversible actions")
});